import { render } from "./Canceled.vue?vue&type=template&id=28bc8bb5&scoped=true"
import script from "./Canceled.vue?vue&type=script&lang=js"
export * from "./Canceled.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28bc8bb5"]])

export default __exports__